<template>
  <div
    class="c-button flex items-center py-3 text-white"
    :class="[
      icon ? 'justify-start' : 'justify-center',
      secondary ? 'secondary' : '',
      { disabled: !confirmedStatus },
    ]"
    :style="buttonStyle"
    @click="handleClick"
  >
    <div v-if="$slots.icon" class="icon-wrapper ml-5 mr-3 flex justify-center">
      <slot name="icon"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import breakpoint from '@/mixins/breakpoint';

export default {
  name: 'CButton',
  mixins: [brandMode, breakpoint],
  props: {
    icon: Boolean,
    secondary: {
      type: Boolean,
      default: false,
    },
    confirmedStatus: {
      type: Boolean,
      default: true,
    },
    width: {
      type: [Number, String],
      default: 246,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      if (this.confirmedStatus) {
        this.$emit('click');
      }
    },
  },
  computed: {
    buttonStyle() {
      // Sanne's default button is 246 wide on phones and 400 on iPad (Figma
      // "Shared Layout Rules"). The width stays an inline decision of this
      // component; an explicit width prop (e.g. "40%") still wins in every mode.
      const isDefaultWidth = this.width === this.$options.props.width.default;
      if (this.isSanne && isDefaultWidth) {
        return { width: this.isLgViewport ? '400px' : '246px' };
      }

      return {
        width: typeof this.width === 'number' ? `${this.width}px` : this.width,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.c-button {
  cursor: pointer;
  max-width: 246px;
  height: 45px;
  min-height: 45px;
  border-radius: 60px;
  box-shadow: 0px 4px 15px 0 rgba(74, 74, 74, 0.25);
  background-image: var(--brand-gradient);
  color: var(--color-on-primary);
  outline: 0;

  &.secondary {
    position: relative;
    color: var(--color-text);
    box-sizing: border-box;
    background: var(--color-surface);
    background-clip: padding-box;
    border: solid 1px var(--color-primary-dark);
    box-shadow: none;
  }
  &.secondary span {
    background: var(--brand-gradient-dark);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus,
  &:focus-within,
  &:focus-visible,
  &:active {
    transform: translateY(1px);
    background-image: var(--brand-gradient-pressed);
  }
}
.icon-wrapper {
  max-width: 25px;
  min-width: 25px;
}
</style>
